import { createRouter, createWebHistory } from 'vue-router'
import { useMainStore } from '@/store'  // 你需要用 pinia 管理 token，或改成你自己的取 token 逻辑
import { showNotify } from 'vant';
import { i18n } from '@/i18n'; // 你的 i18n 实例
import layout from "@/layout/basic/index.vue"
import login from "@/views/login/index.vue"
import register from "@/views/register/index.vue"
import home from "@/views/index/index.vue"
import transaction from "@/views/transaction/index.vue"
import market from "@/views/market/index.vue"
import asset from "@/views/asset/index.vue"
import mine from "@/views/mine/index.vue"

const routes = [
  {
    path: '/',
    // redirect: '/',
    component: layout,
    children: [{
      path: '',
      component: login,
      name: "login",
      meta: {
        title: '登录',
        keepAlive: false,
        requiresAuth: true, //登录权限
        preload: true
      },
    }, {
      path: '/register',
      component: register,
      name: "register",
      meta: {
        title: '注册',
        keepAlive: false,
        requiresAuth: true, //登录权限
        preload: true
      },
    },
    {
      path: '/home',
      component:home,
      name: "index",
      meta: {
        title: '首页',
        keepAlive: false,
        requiresAuth: true, //登录权限
        preload: true
      },
    }, {
      path: '/transaction',
      component: transaction,
      name: "transaction",
      meta: {
        title: '持仓',
        keepAlive: false,
        requiresAuth: true, //登录权限
        preload: true
      },
    }, {
      path: '/market',
      component: market,
      name: "market",
      meta: {
        title: '行情',
        keepAlive: false,
        requiresAuth: true, //登录权限
        preload: true
      },
    }, {
      path: '/asset',
      component: asset,
      name: "asset",
      meta: {
        title: '资产',
        keepAlive: true,
        requiresAuth: true, //登录权限
        preload: true
      },
    }, {
      path: '/mine',
      component: mine,
      name: "mine",
      meta: {
        title: '我的',
        keepAlive: true,
        requiresAuth: true, //登录权限
        preload: true
      },
    }, {
      path: '/mail',
      component: () => import('@/views/mail/index.vue'),
      name: "mail",
      meta: {
        title: '邮件通知',
        keepAlive: false,
        requiresAuth: true, //登录权限
      },
    }, {
      path: '/otc',
      component: () => import('@/views/otc/index.vue'),
      name: "otc",
      meta: {
        title: 'otc',
        keepAlive: false,
        requiresAuth: true, //登录权限
      },
    }, {
      path: '/ipo',
      component: () => import('@/views/ipo/index.vue'),
      name: "ipo",
      meta: {
        title: 'ipo',
        keepAlive: false,
        requiresAuth: true, //登录权限
      },
    }, {
      path: '/etf',
      component: () => import('@/views/etf/index.vue'),
      name: "etf",
      meta: {
        title: 'etf',
        keepAlive: false,
        requiresAuth: true, //登录权限
      },
    }, {
      path: '/dayTrading',
      component: () => import('@/views/dayTrading/index.vue'),
      name: "dayTrading",
      meta: {
        title: '後台建倉',
        keepAlive: false,
        requiresAuth: true, //登录权限
      },
    }, {
      path: '/realNameAuthentication',
      component: () => import('@/views/realNameAuthentication/index.vue'),
      name: "realNameAuthentication",
      meta: {
        title: '實名認證',
        keepAlive: false,
        requiresAuth: true, //登录权限
      },
    }, {
      path: '/positionDetails',
      component: () => import('@/views/positionDetails/index.vue'),
      name: "positionDetails",
      meta: {
        title: '投資詳情',
        keepAlive: false,
        requiresAuth: true, //登录权限
      },
    }, {
      path: '/newsDetail',
      component: () => import('@/views/newsDetail/index.vue'),
      name: "newsDetail",
      meta: {
        title: '資訊',
        keepAlive: false,
        requiresAuth: true, //登录权限
      },
    }, {
      path: '/withdrawal',
      component: () => import('@/views/withdrawal/index.vue'),
      name: "withdrawal",
      meta: {
        title: '提現',
        keepAlive: false,
        requiresAuth: true, //登录权限
      },
    }, {
      path: '/fundAccountManage',
      component: () => import('@/views/fundAccountManage/index.vue'),
      name: "fundAccountManage",
      meta: {
        title: '財務帳戶管理',
        keepAlive: false,
        requiresAuth: true, //登录权限
      },
    }, {
      path: '/addDebitCard',
      component: () => import('@/views/addDebitCard/index.vue'),
      name: "addDebitCard",
      meta: {
        title: '添加銀行卡',
        keepAlive: false,
        requiresAuth: true, //登录权限
      },
    }, {
      path: '/assetConversion',
      component: () => import('@/views/assetConversion/index.vue'),
      name: "assetConversion",
      meta: {
        title: '資產轉換',
        keepAlive: false,
        requiresAuth: true, //登录权限
      },
    }, {
      path: '/fundingRecords',
      component: () => import('@/views/fundingRecords/index.vue'),
      name: "fundingRecords",
      meta: {
        title: '資金記錄',
        keepAlive: false,
        requiresAuth: true, //登录权限
      },
    }, {
      path: '/fundPassword',
      component: () => import('@/views/fundPassword/index.vue'),
      name: "fundPassword",
      meta: {
        title: '資金密碼',
        keepAlive: false,
        requiresAuth: true, //登录权限
      },
    }, {
      path: '/updateLoginPassword',
      component: () => import('@/views/updateLoginPassword/index.vue'),
      name: "updateLoginPassword",
      meta: {
        title: '修改登入密碼',
        keepAlive: false,
        requiresAuth: true, //登录权限
      },
    }, {
      path: '/marketDetail',
      component: () => import('@/views/marketDetail/index.vue'),
      name: "marketDetail",
      meta: {
        title: '行情',
        keepAlive: false,
        requiresAuth: true, //登录权限
      },
    }, {
      path: '/marketDetail1',
      component: () => import('@/views/marketDetail1/index.vue'),
      name: "marketDetail1",
      meta: {
        title: '行情',
        keepAlive: false,
        requiresAuth: true, //登录权限
      },
    }, {
      path: '/topUp',
      component: () => import('@/views/topUp/index.vue'),
      name: "topUp",
      meta: {
        title: '充值',
        keepAlive: false,
        requiresAuth: true, //登录权限
      },
    }, {
      path: '/aiTransactionRecords',
      component: () => import('@/views/aiTransactionRecords/index.vue'),
      name: 'aiTransactionRecords',
      meta: {
        title: 'AI交易记录',
        keepAlive: false,
        requiresAuth: true, //登录权限
      },
    }, {
      path: '/aiTransactionDetails',
      component: () => import('@/views/aiTransactionDetails/index.vue'),
      name: "aiTransactionDetails",
      meta: {
        title: 'AI交易详情',
        keepAlive: false,
        requiresAuth: true, //登录权限
      },
    }, {
      path: '/faq',
      component: () => import('@/views/faq/index.vue'),
      name: "faq",
      meta: {
        title: '常见问题',
        keepAlive: true,
        requiresAuth: true, //登录权限
      },
    }, {
      path: '/about',
      component: () => import('@/views/about/index.vue'),
      name: "about",
      meta: {
        title: '关于我们',
        keepAlive: true,
        requiresAuth: true, //登录权限
      },
    }, {
      path: '/loan',
      component: () => import('@/views/loan/index.vue'),
      name: "loan",
      meta: {
        title: '贷款',
        keepAlive: false,
        requiresAuth: true, //登录权限
      },
    }, {
      path: '/loanRecords',
      component: () => import('@/views/loanRecords/index.vue'),
      name: "loanRecords",
      meta: {
        title: '贷款记录',
        keepAlive: false,
        requiresAuth: true, //登录权限
      },
    },
    {
      path: '/bankType',
      component: () => import('@/views/topUp/bankType.vue'),
      name: "bankType",
      meta: {
        title: '充值',
        keepAlive: false,
        requiresAuth: true, //登录权限
      },
    },
    {
      path: '/bankTypeWeb',
      component: () => import('@/views/topUp/bankTypeWeb.vue'),
      name: "bankTypeWeb",
      meta: {
        title: '充值',
        keepAlive: false,
        requiresAuth: true, //登录权限
      },
    },
    {
      path: '/withdrawalu',
      component: () => import('@/views/withdrawalu/index.vue'),
      name: "withdrawalu",
      meta: {
        title: 'u提现',
        keepAlive: false,
        requiresAuth: true, //登录权限
      },
    },
    {
      path: '/AiTrialBonus',
      component: () => import('@/views/AiTrialBonus/index.vue'),
      name: "AiTrialBonus",
      meta: {
        title: '体验金ai',
        keepAlive: false,
        requiresAuth: true, //登录权限
      },
    },
    {
      path: '/oneStocks',
      component: () => import('@/views/oneStocks/index.vue'),
      name: "oneStocks",
      meta: {
        title: '个股',
        keepAlive: false,
        requiresAuth: true, //登录权限
      },
    },
    {
      path: '/trade',
      component: () => import('@/views/trade/index.vue'),
      name: "trade",
      meta: {
        title: '交易',
        keepAlive: false,
        requiresAuth: true, //登录权限
      },
    },{
      path: '/antiFraud',
      component: () => import('@/views/antiFraud/index.vue'),
      name: "antiFraud",
      meta: {
        title: '反欺诈专区',
        keepAlive: false,
        requiresAuth: true, //登录权限
      },
    },{
      path: '/qzdetails',
      component: () => import('@/views/antiFraud/details.vue'),
      name: "qzdetails",
      meta: {
        title: '反欺诈专区-详情',
        keepAlive: false,
        requiresAuth: true, //登录权限
      },
    },{
      path: '/qzdetails2',
      component: () => import('@/views/antiFraud/details2.vue'),
      name: "qzdetails2",
      meta: {
        title: '反欺诈专区-详情',
        keepAlive: false,
        requiresAuth: true, //登录权限
      },
    },{
      path: '/Regulatorynfo',
      component: () => import('@/views/Regulatorynfo/index.vue'),
      name: "Regulatorynfo",
      meta: {
        title: '监管信息',
        keepAlive: false,
        requiresAuth: false, //登录权限
      },
    },{
      path: '/riskDisclosure',
      component: () => import('@/views/riskDisclosure/index.vue'),
      name: "riskDisclosure",
      meta: {
        title: '风险披露',
        keepAlive: false,
        requiresAuth: false, //登录权限
      },
    },{
      path: '/newsHighlights',
      component: () => import('@/views/newsHighlights/index.vue'),
      name: "newsHighlights",
      meta: {
        title: '新闻热点',
        keepAlive: false,
        requiresAuth: false, //登录权限
      },
    },
    ]
  }
  // {
  //   path: '/',
  //   name: 'Home',
  //   component: () => import('@/views/Home.vue'),
  //   meta: { requiresAuth: true }, // 需要登录权限
  // }
]

const router = createRouter({
  history: createWebHistory(),
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;  // 返回保存的滚动位置
    }
    return { top: 0 };  // 默认情况下跳转时滚动到顶部
  }
})

router.beforeEach((to, from, next) => {
  const mainStore = useMainStore()
  // console.log(to);

  if (to.path != '/' && to.path != '/register') {
    if (to.meta.requiresAuth && !mainStore.token) {
      const t = i18n.global.t; // 直接使用 i18n 实例的 t
      showNotify({ type: 'warning', message: t('newRouter.a1') })
      return next('/') // 跳转登录页
    }
  }

  next()
})

export default router
